import React, { forwardRef } from 'react';
import { SvgImdb } from '../../../icons';
import { Layout } from '../../../queries/ats/layout/types';
import { AtsItem } from '../AtsItem/AtsItem';
import { Image } from '../../image/Image';
import css from './ats-carousel.module.scss';
import { getSectionItemImage } from '../../../utils/atsLayoutUtils';

export interface CarouselCardProps extends React.ComponentProps<'a'> {
  item: Layout.SectionItem;
  pattern: Layout.Pattern;
  isActive: boolean;
}

export const CarouselCard = forwardRef<HTMLAnchorElement, CarouselCardProps>(
  ({ item, pattern, isActive, onClick, ...rest }, ref) => {
    const title = item.name || item.title?.titleName;

    return (
      <AtsItem
        data-pattern="wide"
        item={item}
        pattern="wide"
        className={css.card}
        data-active={isActive}
        ref={ref}
        {...rest}
        onClick={(event) => {
          if (!isActive) {
            event.preventDefault();
            onClick?.(event);
          }
        }}
      >
        {item.title && item.title.scoreRating && item.title.scoreRating.imdb && (
          <span className={css.rating}>
            <SvgImdb width={16} height={14} />
            <span>{item.title.scoreRating.imdb}</span>
          </span>
        )}
        <Image className={css.image} src={getSectionItemImage(item, pattern, 'wide')} alt={item.name} />
        {isActive && title ? <span className={css.title}>{title}</span> : null}
      </AtsItem>
    );
  },
);
